import './Logo.css';

import type { FunctionComponent } from 'react';

import logo from '../../assets/logo.svg';

interface LogoProps {
  onClick?: () => void;
}

export const Logo: FunctionComponent<LogoProps> = ({ onClick }) => {
  return (
    <div
      className={onClick === undefined ? '' : 'logo-clickable'}
      onClick={onClick}
    >
      <img src={logo} height={36} />
    </div>
  );
};
